import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameIntroScene } from 'src/games/ColonyGame/scenes/GameIntro';

interface PhaserColonyGameProps {
    onComplete: () => void;
}

interface PhaserColonyGameState {
}

const gameConfig: GameConfig = {
    title: "Colony Game",
    version: "0.9.3",
    backgroundColor: "#000000"
};

class PhaserColonyGame extends React.Component<PhaserColonyGameProps, PhaserColonyGameState> {
    private game: Phaser.Game;
    constructor(props: PhaserColonyGameProps) {
        super(props);
        bindAllOfThis(this, PhaserColonyGame.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={GameIntroScene} config={gameConfig} onComplete={this.props.onComplete}/>
        </div>);
    }
}

export default PhaserColonyGame;



// WEBPACK FOOTER //
// ./src/games/ColonyGame/Main.tsx